import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import AxiosPostProcessor from './AxiosPostProcessor';
import Axios, { AxiosResponse } from 'axios';
import RideWithGpsSaveRequest from '@/RideWithGpsSaveRequest';
import QueryStringUtility from './QueryStringUtility';
import RideWithGpsMigrationStatus from './RideWithGpsMigrationStatus';
import RideWithGpsIntegrationStatus from './RideWithGpsIntegrationStatus';
import { apiNavigationBaseUrl } from './ApiBaseUrl';

export const RideWithGpsMigrationPath = '/ridewithgps/migrate';

export class RideWithGpsServiceStatic {
    beginLinkWithRideWithGpsUrl(state?: string) {
        return `${apiNavigationBaseUrl()}/api/secure/user/ridewithgps/link${QueryStringUtility.getQueryString({state})}`;
    }

    migrationSplashUrl() { return `${process.env.BASE_URL}migrate-from-ridewithgps`; }

    migrationEventsUrl(jobId: string) {
        return `${process.env.VUE_APP_BASE_URL_API}/api/secure/subscriber/ridewithgps/migration/events${QueryStringUtility.getQueryString({ jobId })}`
    }

    linkWithRideWithGps(code: string): Promise<AxiosResponse<void>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/user/ridewithgps/link${QueryStringUtility.getQueryString({code})}`
        return AxiosPostProcessor.postProcess(Axios.post<void>(url, undefined, AxiosDefaultRequestConfig.merge({ })));
    }

    getIntegrationStatus(): Promise<AxiosResponse<RideWithGpsIntegrationStatus>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/user/ridewithgps/integration`
        return AxiosPostProcessor.postProcess(Axios.get<RideWithGpsIntegrationStatus>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    unlinkFromRideWithGps(): Promise<AxiosResponse<void>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/user/ridewithgps/link`
        return AxiosPostProcessor.postProcess(Axios.delete<void>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    saveToRideWithGps(saveRequest: RideWithGpsSaveRequest): Promise<AxiosResponse<void>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/subscriber/ridewithgps/save`
        return AxiosPostProcessor.postProcess(Axios.post<void>(url, saveRequest, AxiosDefaultRequestConfig.merge({ })));
    }

    startMigration(): Promise<AxiosResponse<RideWithGpsMigrationStatus>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/subscriber/ridewithgps/migration/start`
        return AxiosPostProcessor.postProcess(Axios.post<RideWithGpsMigrationStatus>(url, undefined, AxiosDefaultRequestConfig.merge({ })));
    }

    authRequiredCodeFromError(error: any) {
        const code = error?.response?.data?.code
        return code === 'ridewithgps_connect_required' || code === 'ridewithgps_reconnect_required'
            ? code
            : null
    }
}
const RideWithGpsService = new RideWithGpsServiceStatic();
export default RideWithGpsService;
